<template>
  <div class="container-md col-lg-10 col-md-10 pt-2 organisation-list">
    <LoadingOverlay v-if="isCustomerFetch" />
    <div class="pb-5 mb-2" v-else>
      <h3 class="text-primary m-1 pt-1 pb-2">
        Non-related Organisations
        <span class="nowrap" style="font-size: 20px">
          ({{ unrelatedOrganisationRelations.length || "0" }} Record
          {{ unrelatedOrganisationRelations.length > 1 ? "s" : "" }})
        </span>
      </h3>
      <div>
        <CTabs variant="tabs" :active-tab="0">
          <CTab :title="'Partner Hospitals' + ` (${partnerHospitals.length}) `">
            <CDataTable
              :striped="striped"
              :bordered="bordered"
              :small="small"
              :items="partnerHospitals"
              :fields="fields"
              :items-per-page="small ? limit : 5"
              sorter
              :tableFilter="{ label: 'Search', placeholder: 'Type for search' }"
              pagination
              class="p-2 border"
            >
              <template #action="{ item }">
                <td class="text-center">
                  <CButton
                    color="success"
                    size="sm"
                    @click="activateOrganisation(item)"
                  >
                    Activate
                  </CButton>
                </td>
              </template>
            </CDataTable>
          </CTab>

          <CTab :title="'Partner Agencies' + ` (${partnerAgencies.length}) `">
            <CDataTable
              :striped="striped"
              :bordered="bordered"
              :small="small"
              :items="partnerAgencies"
              :fields="fields"
              :items-per-page="small ? limit : 5"
              sorter
              :tableFilter="{ label: 'Search', placeholder: 'Type for search' }"
              pagination
              class="p-2 border"
            >
              <template #action="{ item }">
                <td class="text-center">
                  <CButton
                    color="success"
                    size="sm"
                    @click="activateOrganisation(item)"
                  >
                    Activate
                  </CButton>
                </td>
              </template>
            </CDataTable>
          </CTab>

          <CTab
            :title="`Educational Institution (${educationalInstitution.length})`"
          >
            <CDataTable
              :striped="striped"
              :bordered="bordered"
              :small="small"
              :items="educationalInstitution"
              :fields="fields"
              :items-per-page="small ? limit : 5"
              sorter
              :tableFilter="{ label: 'Search', placeholder: 'Type for search' }"
              pagination
              class="p-2 border"
            >
              <template #action="{ item }">
                <td class="text-center">
                  <CButton
                    color="success"
                    size="sm"
                    @click="activateOrganisation(item)"
                  >
                    Activate
                  </CButton>
                </td>
              </template>
            </CDataTable>
          </CTab>

          <CTab :title="`Training Course (${trainingCourse.length})`">
            <CDataTable
              :striped="striped"
              :bordered="bordered"
              :small="small"
              :items="trainingCourse"
              :fields="fields"
              :items-per-page="small ? limit : 5"
              sorter
              :tableFilter="{ label: 'Search', placeholder: 'Type for search' }"
              pagination
              class="p-2 border"
            >
              <template #action="{ item }">
                <td class="text-center">
                  <CButton
                    color="success"
                    size="sm"
                    @click="activateOrganisation(item)"
                  >
                    Activate
                  </CButton>
                </td>
              </template>
            </CDataTable>
          </CTab>

          <CTab :title="`Visa Licensing (${visaLicensing.length})`">
            <CDataTable
              :striped="striped"
              :bordered="bordered"
              :small="small"
              :items="visaLicensing"
              :fields="fields"
              :items-per-page="small ? limit : 5"
              sorter
              :tableFilter="{ label: 'Search', placeholder: 'Type for search' }"
              pagination
              class="p-2 border"
            >
              <template #action="{ item }">
                <td class="text-center">
                  <CButton
                    color="success"
                    size="sm"
                    @click="activateOrganisation(item)"
                  >
                    Activate
                  </CButton>
                </td>
              </template>
            </CDataTable>
          </CTab>

          <CTab :title="'Others' + ` (${otherOrganisations.length}) `">
            <CDataTable
              :striped="striped"
              :bordered="bordered"
              :small="small"
              :items="otherOrganisations"
              :fields="fields"
              :items-per-page="small ? limit : 5"
              sorter
              :tableFilter="{ label: 'Search', placeholder: 'Type for search' }"
              pagination
              class="p-2 border"
            >
              <template #action="{ item }">
                <td class="text-center">
                  <CButton
                    color="success"
                    size="sm"
                    @click="activateOrganisation(item)"
                  >
                    Activate
                  </CButton>
                </td>
              </template>
            </CDataTable>
          </CTab>
        </CTabs>
      </div>
    </div>

    <OrganisationEdit
      v-if="organisationEditModal.isShowPopup"
      :organisationDetail="organisationEditModal.organisation"
      :isShowPopup="organisationEditModal.isShowPopup"
      @modalCallBack="organisationModalCallBack"
    />
    <CModal
      :show.sync="confirmationModal.isShowPopup"
      color="primary"
      title="Enable Organisation Relation?"
    >
      <div>
        Are you sure you want to enable the relation for the selected
        organisation?
      </div>
      <template #footer>
        <CButton color="secondary" @click="cancelActivation">Cancel</CButton>
        <CButton color="primary" @click="confirmActivation">Yes</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { getLocalOrgDetail } from "@/helpers/helper";
import OrganisationEdit from "@/containers/Organisation/EditOrganisation";

export default {
  components: {
    OrganisationEdit,
  },
  data() {
    return {
      limit: 5,
      small: true,
      striped: true,
      bordered: true,
      fields: [
        {
          key: "organisation_name",
          label: "Organisation Name",
          _style: "width:25%",
        },
        // { key: "customer_name", label: "Customer Name", _style: "width:15%" },
        { key: "path_acronym", label: "Path Acronym", _style: "width:10%" },
        // { key: "organisation_type", label: "Organisation Type", _style: "width:15%" },
        { key: "city", _style: "width:10%" },
        {
          key: "main_contact_name",
          label: "Main Contact Name",
          _style: "width:15%;white-space:nowrap",
        },
        { key: "email", label: "Email", _style: "width:15%" },
        {
          key: "action",
          label: "Action",
          sorter: false,
          filter: false,
          _style: "width:10%",
        },
      ],
      organisationEditModal: {
        isShowPopup: false,
        organisation: null,
        organisationID: null,
      },
      confirmationModal: {
        isShowPopup: false,
        organisation: null,
      },
    };
  },
  watch: {
    "getOrgDetail.customer_organisation_id": function () {
      this.fetchUnrelatedOrganisationRelations();
    },
  },
  computed: {
    ...mapGetters([
      "unrelatedOrganisationRelations",
      "isCustomerFetch",
      "getUser",
      "getOrgDetail",
    ]),
    organisations() {
      return (
        (this.unrelatedOrganisationRelations &&
          this.unrelatedOrganisationRelations.length &&
          this.unrelatedOrganisationRelations
            .map(({ organisation, ...rest }) => ({
              organisation_name: organisation?.name,
              // customer_name: customer?.name || "--",
              organisation_type:
                organisation?.organisation_type?.organisation_type,
              organisation_type_id:
                organisation?.organisation_type?.organisation_type_id,
              main_contact_name: organisation?.main_contact?.name,
              email: organisation?.main_contact?.email,
              organisation_id: organisation?.organisation_id,
              city: rest?.customer_organisation_location
                ? rest?.customer_organisation_location
                    .map((val) => val?.location?.location)
                    .join()
                : "--",
              path_acronym: rest?.path_acronym || "--",
              cust_org_id: rest?.id,
            }))
            .reverse()) ||
        []
      );
    },
    partnerHospitals() {
      return this.organisations.filter((o) => o.organisation_type_id === 16);
    },
    partnerAgencies() {
      return this.organisations.filter((o) => o.organisation_type_id === 13);
    },
    educationalInstitution() {
      return this.organisations.filter((o) => o.organisation_type_id === 18);
    },
    trainingCourse() {
      return this.organisations.filter((o) => o.organisation_type_id === 20);
    },
    visaLicensing() {
      return this.organisations.filter((o) => o.organisation_type_id === 21);
    },
    otherOrganisations() {
      return this.organisations.filter(
        (o) => ![13, 16, 18, 20, 21].includes(o.organisation_type_id)
      );
    },
  },
  methods: {
    ...mapActions([
      "fetchUnrelatedOrganisationRelations",
      "createRelationship",
    ]),
    activateOrganisation(item) {
      this.confirmationModal.organisation = item;
      this.confirmationModal.isShowPopup = true;
    },
    confirmActivation() {
      const item = this.confirmationModal.organisation;
      this.confirmationModal.isShowPopup = false;
      this.createRelationship(item.cust_org_id).then(async () => {
        await this.fetchUnrelatedOrganisationRelations();
      });
    },
    cancelActivation() {
      this.confirmationModal.isShowPopup = false;
      this.confirmationModal.organisation = null;
    },
  },
  mounted() {
    this.fetchUnrelatedOrganisationRelations()
  }
};
</script>
